var _InfoIcon;
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import clsx from 'clsx';
import { Button, DisclaimerText, InfoIcon, SubHeading, Table } from 'reaxl';
import EmailContext from '../EmailContext';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const renderTableRow = (content, isNdsCalc) => {
  const {
    label,
    value,
    isTotalValue
  } = content;
  const labelClassName = clsx({
    'margin-right-5': !isNdsCalc,
    'margin-top-3': isTotalValue
  }, 'pull-left');
  const valueClassName = clsx({
    'text-size-500 margin-top-3': isTotalValue
  }, 'text-bold pull-right');
  if (label === 'Taxes & Fees') {
    return /*#__PURE__*/_jsxs("tr", {
      children: [/*#__PURE__*/_jsxs("td", {
        className: labelClassName,
        children: [label, "\xA0", _InfoIcon || (_InfoIcon = /*#__PURE__*/_jsx(InfoIcon, {
          placement: "top",
          infoText: "Usually includes sales tax, DMV fees, any lender fees for financing, plus dealer-related fees for doc and prep",
          id: "taxes-and-fees-info",
          className: "text-size-300"
        }))]
      }), /*#__PURE__*/_jsx("td", {
        className: valueClassName,
        children: value
      })]
    }, label);
  }
  return (value !== '$0' || value === '$0' && label === 'Estimated Cash Out of Pocket') && /*#__PURE__*/_jsxs("tr", {
    children: [/*#__PURE__*/_jsx("td", {
      className: labelClassName,
      children: label
    }), /*#__PURE__*/_jsx("td", {
      className: valueClassName,
      children: value
    })]
  }, label);
};
function WalletSnapshot(_ref) {
  let {
    action = {},
    contents = [],
    tableClassName,
    title,
    disclaimer
  } = _ref;
  const {
    uiContext
  } = useContext(EmailContext);
  if (!contents.length) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!!Object.keys(action).length && /*#__PURE__*/_jsx(Button, {
      bsStyle: "text",
      className: "pull-right text-size-300",
      onClick: action.onClick,
      children: action.label
    }), /*#__PURE__*/_jsx(SubHeading, {
      size: 400,
      children: title
    }), !!disclaimer && /*#__PURE__*/_jsx(DisclaimerText, {
      weight: "normal",
      children: disclaimer
    }), /*#__PURE__*/_jsx(Table, {
      className: clsx(tableClassName, 'margin-top-2 table-unstyled'),
      children: /*#__PURE__*/_jsx("tbody", {
        children: contents.map(content => renderTableRow(content, uiContext === 'calculator'))
      })
    })]
  });
}
export default WalletSnapshot;